import * as React from 'react';
import { KonkurrenceJumbotron } from '../../konkurrence/KonkurrenceJumbotron';
import OpgaveCard from '../../konkurrence/OpgaveCard';
import { Row } from '../../../uiComponents/bootstrap-components/BootstrapComponents';
import { KonkurrenceHold } from '../../../models/KonkurrenceHold';
import { Jumbotron } from '../../../uiComponents/Jumbotron';
import * as moment from 'moment';
import { getLoggedInBruger, erKonkurrenceDag } from '../../../infrastructure/Security';
import bedoemmesAfTilRolleMap from '../../../models/mappers/BedoemmesAfTilRolleMap';
import { KonkurrenceAfviklingssted } from '../../../models/KonkurrenceAfviklingssted';

export interface KonkurrenceOverblikPresenterProps {
    konkurrencetitel: string;
    konkurrenceDate: Date;
    konkurrenceAfviklingssted?: KonkurrenceAfviklingssted;
    konkurrenceId: string;
    billedId: string;
    hold: KonkurrenceHold;
    beskrivelse: string;
    showSamletPlacering: boolean;
}

export default class KonkurrenceOverblikPresenter extends React.Component<KonkurrenceOverblikPresenterProps, any> {

    constructor(props: KonkurrenceOverblikPresenterProps) {
        super(props);

        this.getOpgaver = this.getOpgaver.bind(this);
        this.wrapOpgaverInRow = this.wrapOpgaverInRow.bind(this);
    }

    wrapOpgaverInRow(opgaver: any, key: number) {
        return (
            <Row key={key} className='opgave-row'>
                {opgaver}
            </Row>
        );
    }    

    getOpgaver() {
        let rows = Array();
        let opgaver = [];
        let i;
        const loggedInRolle = getLoggedInBruger().rolle;
        const erKonkurrenceIdag = erKonkurrenceDag(this.props.konkurrenceDate);
        for (i = 0; i < this.props.hold.opgaver.length; i++) {
            let opgave = this.props.hold.opgaver[i];            
            const kanBedoemme = opgave.opgaveDelopgaverBedoemmesAf.some(d => bedoemmesAfTilRolleMap(d).indexOf(loggedInRolle) !== -1);
            
            opgaver.push(
                <OpgaveCard
                    key={i}
                    opgave={opgave}
                    konkurrenceId={this.props.konkurrenceId}
                    opgavepakkeOpgaveId={opgave.opgavepakkeOpgaveId}
                    holdId={this.props.hold.holdId}
                    isEnabled={opgave.synlig}
                    showSamletPlacering={this.props.showSamletPlacering}
                    showResultatButton={erKonkurrenceIdag}
                    kanBedoemme={kanBedoemme}
                    erPaaVenteListeVisning={this.props.hold.erPaaVenteliste}
                />
            );

            if (opgaver.length % 3 === 0) {
                rows.push(this.wrapOpgaverInRow(opgaver, i));
                opgaver = Array();
            }
        }
        rows.push(this.wrapOpgaverInRow(opgaver, i++));

        return rows;
    }

    renderOpgaver() {
        const opgaver = this.getOpgaver();

        if (this.props.hold.opgaver.length > 0) {
            return (
                <div className='opgave-overblik'>
                    {opgaver}
                </div>
            );
        } else {
            const formattedDate = moment(this.props.hold.opgaverSynligFra.toString()).format('DD.MM.YY');
            const text = 'Opgaverne er først synlige fra ' + formattedDate;
            return (<Jumbotron title='Opgaver' message={text} icon='warning' />);
        }
    }

    render() {
        const opgavepakkeIds = new Array();
        opgavepakkeIds.push(this.props.hold.opgavepakkeId);

        return (
            <div>                
                <KonkurrenceJumbotron
                    konkurrenceTitel={this.props.konkurrencetitel}
                    konkurrenceDate={this.props.konkurrenceDate}
                    konkurrenceAfviklingssted={this.props.konkurrenceAfviklingssted}
                    samletPlacering={this.props.hold.samletPlacering}
                    konkurrenceId={this.props.konkurrenceId}
                    opgavepakkeNavn={this.props.hold.opgavepakkeNavn}
                    billedId={this.props.billedId}
                    beskrivelse={this.props.beskrivelse}
                    showSamletPlacering={this.props.showSamletPlacering}
                    opgavepakkeIds={opgavepakkeIds}
                />
                {this.renderOpgaver()}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/skrivebord/konkurrenceOverblik/KonkurrenceOverblikPresenter.tsx